// Form validation for Holiday Input form
import { plaintextValidator, dropdownValidator } from '../fields';

const config = { mandatory: true };

export default {
  day: dropdownValidator(config),
  month: dropdownValidator(config),
  description: plaintextValidator(config)
};
